import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectGlobalShipXAgencyMappingsListItems } from "../../../../../../redux/global-shipx-agency/selector";
import { globalShipXAgencyMappings } from "../../../../../../redux/global-shipx-agency/action";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";


const GlobalShipXCloudMappings = ({id}: any) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const globalShipXCloudMappingItems = useSelector(selectGlobalShipXAgencyMappingsListItems)
    console.log(globalShipXCloudMappingItems, "globalShipXCloudMappingItems")
    localStorage.removeItem('storageKey')
    const [
        columnDefs,
        setColumnDefs
    ] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'PartnerGlobalDBARegistryName', headerName: 'Partner Global DBA Registry Name' },
            { field: 'InternalGlobalDBARegistryName', headerName: 'Internal Global DBA Registry Name' },
             { field: 'IsUpstreamProvider', headerName: 'Upstream Provider', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
            { field: 'IsChannelProvider', headerName: 'Channel Provider', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
            { field: 'GlobalShipXProgramParticipantName', headerName: 'Global ShipX Program Participant Network' },
            { field: 'GlobalShipXProgramParticipantType', headerName: 'Global ShipX Program Participant Type' },
            { field: 'IsActive', headerName: 'Is Active', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
           

        ]);
    }
 
    const fetchglobalShipXAgencyMappings = () => {
        dispatch(globalShipXAgencyMappings.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-ShipX-agency-mappings/fetch`, entity: 'globalShipXAgencyMapping', jsonData: {

                "Context": {},
                "Records": [
                    {
                        "GlobalChannelShipXProgramId": id
                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalShipXAgencyMappingId",
                    "SortOrder": "desc",
                }

            }
        }))
    }
   
    const handleEdit = (data: any) => {
        navigate(`${data.GlobalShipXAgencyMappingId}`)
    }

    const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }

        dispatch(globalShipXAgencyMappings.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-ShipX-agency-mappings/fetch`, entity: 'GlobalShipXAgencyMapping', jsonData: {

                "Context": {},
                "Records": [
                    {
 "GlobalChannelShipXProgramId": id
                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalShipXAgencyMappingId",
                    "SortOrder": "desc",
                    "Searches": searchCriteria,
                }


            }
        }))
    }

    const handleReloadData = () => {
        dispatch(globalShipXAgencyMappings.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-ShipX-agency-mappings/fetch`, entity: 'GlobalShipXAgencyMapping', jsonData: {
                "Context": {},
                "Records": [
                    {
 "GlobalChannelShipXProgramId": id
                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalShipXAgencyMappingId",
                    "SortOrder": "desc",
                }


            }
        }))
    }
    const filterTypes = [{
        name: 'Text', value: "text"
    },
    {
        name: 'Number', value: "number"
    },
    {
        name: 'CheckBox', value: "checkbox"
    },
    {
        name: 'Date', value: "date"
    }
    ]
    const additionButtons: any = [
        {
            svg: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <title>Reload</title>
                    <path
                        d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
            callback: () => handleReloadData(),
        },
        // {
        //     name: "Create Existing",
        //     callback: () => handleCreateExisting(),
        // },
    ];

    useEffect(() => {
        createColumnDefs()
        fetchglobalShipXAgencyMappings()
    }, [pageData, pageSize])

    const handleDelete = (data: any) => {
        dispatch(globalShipXAgencyMappings.delete({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-ShipX-agency-mappings/delete`,
            entity: 'globalShipXAgencyMapping',
            jsonData: {
                Records: [
                    {

                        Id: data?.GlobalShipXAgencyMappingId
                    }

                ]
            }
        })).then(() => {
            dispatch(globalShipXAgencyMappings.list({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-ShipX-agency-mappings/fetch`, entity: 'globalShipXCloudMapping', jsonData: {

                    "Context": {},
                    "Records": [
                        {
 "GlobalChannelShipXProgramId": id
                        }
                    ],
                    "Pagination": {
                        "PageNumber": pageData,
                        "PageSize": pageSize,
                        "SortField": "GlobalShipXAgencyMappingId",
                        "SortOrder": "desc",
                    }

                }
            }))
        });
    }
    return (
        <>
            {globalShipXCloudMappingItems?.isLoading ? <PageLoader /> :
                <Table columnData={columnDefs} additionButtons={additionButtons} enableFilter={true}
                    filterTypeLists={filterTypes}
                    onSearch={handleSearch} rowData={globalShipXCloudMappingItems?.result?.items} setPageData={setPageData}
                    paginationData={globalShipXCloudMappingItems?.result?.pagination}
                    onEdit={handleEdit} setPageSize={setPageSize} headingName="Global ShipX Agency Mappings" />
            }
        </>
    );
};

export default GlobalShipXCloudMappings;


